/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Actions from '../../../../actions'
import PageCard from '../../../common/PageCard'
import VerificationCodeInput from '../../../common/VerificationCodeInput'
import { Button, Spin } from 'antd'
import $t from '../../../../i18n'
import Page from '../../../common/Page'
import Card from '../../../common/Card'
import MaterialInput from '../../../common/MaterialInput'
import { COUNTRY_CODES } from '../../../../consts'
import { isProduction } from '../../../../utils/envUtils'
import { isEmpty } from 'ramda'
import { event, eventTypes } from '../../../../consts/eventConsts'
import { formatClientSideError } from '../../../../utils/eventUtils'
import VerifyPhoneCode from '../../VerifyPhoneCode'
import { getUrlParams } from '../../../../utils/useParamUtil'

import './QuickSignUp.css'

//todo validate ssn is not empty
const getValidationErrors = ({ phoneNumber, ssn }) => {
  const result = {}
  const numericRegex = /^\d{10}$/

  if (!phoneNumber) {
    result.phoneNumber = $t('errors.validation.missing')
  }
  if (!phoneNumber.match(numericRegex)) {
    result.phoneNumber = $t('errors.validation.invalidPhone')
  }
  if (!ssn) {
    result.ssn = $t('errors.validation.missing')
  } else if (ssn?.length < 4) {
    result.ssn = $t('errors.validation.invalidSSN')
  }
  return (!isEmpty(result) && result) || null
}

const QuickSignUp = () => {
  const dispatch = useDispatch()

  const {
    isSignupPhoneNumberLoading,
    isSignupPhoneNumberSuccess,
    isVerificationCodeInvalid,
    signupFormErrorMessage,
    hmoFirstLogin,
  } = useSelector(state => state.signup)

  const isQuickSignupLoading = useSelector(
    state => state.auth.isQuickSignupLoading
  )

  const urlParams = getUrlParams()

  const defaultPhoneNumber = isProduction
    ? {
        short: 'US',
        code: COUNTRY_CODES[0],
        phone: '',
      }
    : {
        code: 972,
        phone: '',
        short: 'IL',
      }

  const [code, setCode] = useState('')
  const [phoneNumber, setPhoneNumber] = useState(defaultPhoneNumber)
  const [shouldValidate, setShouldValidate] = useState(false)

  const errors =
    shouldValidate &&
    getValidationErrors({
      phoneNumber: phoneNumber?.phone,
      ssn: code,
    })

  useEffect(() => {
    if (!!urlParams?.locale) {
      dispatch(
        Actions.createAction(Actions.SELECT_CHANGE_LOCALE_REQUESTED, {
          locale: urlParams?.locale,
        })
      )
    }
    // in case we get the token from url, we will skip the first page
    // of the quick signup and go directly to the verification code page
    const token = urlParams?.token
    if (token) {
      dispatch(
        Actions.createAction(Actions.QUICK_SIGNUP_REQUESTED, {
          token,
          utm_source: urlParams?.utm_source,
        })
      )
      dispatch(
        Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
          type: eventTypes.formEvent,
          eventName: event.formEvent.submit,
          data: { utm_source: urlParams?.utm_source },
          element: 'next quick account Setup',
        })
      )
    }
  }, [])

  useEffect(() => {
    if (hmoFirstLogin?.phoneNumber && isSignupPhoneNumberSuccess) {
      // take last 10 digits
      const phoneWithoutCode = hmoFirstLogin?.phoneNumber?.substring(
        hmoFirstLogin?.phoneNumber?.length - 10
      )
      const code = hmoFirstLogin?.phoneNumber?.substring(
        0,
        hmoFirstLogin?.phoneNumber?.length - 10
      )
      setPhoneNumber({ phone: phoneWithoutCode, code: code })
    }
  }, [isSignupPhoneNumberSuccess])

  const handleNext = () => {
    // remove '-' and '.' chars from number, is exists. remove spaces
    const phoneWithoutChars = phoneNumber?.phone
      ? phoneNumber?.phone
          .toString()
          .replace(new RegExp('[-.]', 'g'), '')
          .replace(/\s/g, '')
      : ''

    const payload = {
      phone: '+' + phoneNumber?.code.toString() + phoneWithoutChars,
      ssn: code,
      utm_source: urlParams?.utm_source,
    }

    const validationErrors = getValidationErrors({
      phoneNumber: phoneWithoutChars,
      ssn: code,
    })

    if (validationErrors) {
      setShouldValidate(true)
      dispatch(
        Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
          type: eventTypes.formEvent,
          eventName: event.formEvent.invalid,
          data: payload,
          element: 'SSN validation error',
          error: formatClientSideError(validationErrors),
        })
      )
      return
    }

    dispatch(Actions.createAction(Actions.QUICK_SIGNUP_REQUESTED, payload))
    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        type: eventTypes.formEvent,
        eventName: event.formEvent.submit,
        data: { phone: payload?.phone },
        element: 'next quick account Setup',
      })
    )
  }

  const renderVerificationCodePage = () => {
    const phoneNumberString = `${phoneNumber.code}${phoneNumber.phone}`
    return (
      <VerifyPhoneCode
        onNext={({ code }) => getVerifyTheCode(code)}
        onResend={() =>
          dispatch(Actions.createAction(Actions.HMO_RESEND_SMS_REQUESTED))
        }
        phone={phoneNumberString}
        loading={isSignupPhoneNumberLoading}
        errorMessage={
          isVerificationCodeInvalid
            ? $t('pages.getStarted.signupForm.invalidCode')
            : ''
        }
      />
    )
  }

  const getVerifyTheCode = async verificationCode => {
    const phoneNumberString = `+${phoneNumber.code}${phoneNumber.phone}`
    dispatch(
      Actions.createAction(Actions.SIGNUP_CODE_VERIFY_REQUESTED, {
        phoneNumber: phoneNumberString,
        value: verificationCode,
        element: 'Enter_the_verification_code',
      })
    )
    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        type: eventTypes.formEvent,
        eventName: event.formEvent.submit,
        element: 'next quick whats the code?',
      })
    )
  }

  const renderQuickSignUpPage = () => {
    return isQuickSignupLoading ? (
      <Spin size="large" className="center-spinner" />
    ) : (
      <PageCard className="login-page-card quick-signup-page-card">
        <Page
          className="login-page quick-signup-page"
          hideAlertBanner={true}
          title={$t('pages.getStarted.signupForm.quickSignupPage.title')}
          subtitle={$t('pages.getStarted.signupForm.quickSignupPage.subtitle')}
        >
          <div className="signup-group-fields">
            <Card className="signup-group-field">
              <div className="field-title">
                {$t('pages.getStarted.signupForm.quickSignupPage.ssn')}
              </div>
              <VerificationCodeInput
                className="verify-ssn-code-input field-value"
                fields={4}
                onChange={v => {
                  setCode(v)
                }}
              />
              <div className="error-text">{errors?.ssn}</div>
            </Card>

            <Card className="signup-group-field">
              <div className="field-title">
                {$t('pages.getStarted.signupForm.phoneNumber')}
              </div>
              <div className="field-sub">
                {$t('pages.getStarted.signupForm.wellTextYouAVerificationCode')}
              </div>
              <MaterialInput
                className="signup-phonenumber field-value"
                label={$t('pages.getStarted.signupForm.phoneNumber')}
                hideLabel
                onChange={e => setPhoneNumber(e)}
                value={phoneNumber}
                type="phone"
                errorText={errors?.phoneNumber}
              />
            </Card>
          </div>
          {signupFormErrorMessage && (
            <div className="signup-server-errors">{signupFormErrorMessage}</div>
          )}
          <Button type="primary" onClick={handleNext}>
            {$t('common.next')}
          </Button>
        </Page>
      </PageCard>
    )
  }

  return isSignupPhoneNumberSuccess
    ? renderVerificationCodePage()
    : renderQuickSignUpPage()
}

export default QuickSignUp
